export default "__VITE_ASSET__BKkTPo$K__"